module.exports = __webpack_public_path__ + "svg/clubs.svg?d290747ed64d9c4d781a36096ccb5e7d";